export default class GridInfo
{
    width:number;
    height:number;
    sizeof:number;
    count:number;
    data?:Int32Array;
    nn_grid_size:number;
    nn_grid_square_count:number;

    constructor(width:number,height:number)
    {
        this.width = width;
        this.height = height;
        this.sizeof = 64;  
        this.count = 16;
        this.nn_grid_size = 0;
        this.nn_grid_square_count = 0;
    }

    getDivsNear(divs0:number, dsize:number)
    {
        let iBest = divs0;
        let minDiff = divs0;
        let i;
        let m;
        let diff;

        let i_start = divs0 / 2;
        for (i = i_start; i < divs0; ++i)
        {
            m = dsize % i;
            if (m != 0) {
                // not an integer divisor
                continue;
            }

            diff = Math.abs(divs0 - i);
            if (diff < minDiff) {
                minDiff = diff;
                iBest = i;
            }
            else if (diff == minDiff && i > iBest) {
                minDiff = diff;
                iBest = i;
            }
        }

        let i_end = divs0 * 3 / 2;
        for (i = divs0; i <= i_end; ++i)
        {
            m = dsize % i;
            if (m != 0) {
                // not an integer divisor
                continue;
            }

            diff = Math.abs(divs0 - i);
            if (diff < minDiff) {
                minDiff = diff;
                iBest = i;
            }
            else if (diff == minDiff && i > iBest) {
                minDiff = diff;
                iBest = i;
            }
        }
        return iBest;
    }

    get_initial_data()
    {
        this.data = new Int32Array(this.count);

        //cbcr_size
        this.data[0] = this.width;
        this.data[1] = this.height;

        //y size
        this.data[2] = this.width;
        this.data[3] = this.height;

        //max_blobs per line
        this.data[4] = 16;

        //max_blobs
        this.data[5] = 256;

        //max sttickers
        this.data[6] = 256;  


        //trigger
        this.data[7] = 31; //BLOB_TRIGGER_BRIGHTNESS

        //min_blob_size
        this.data[8] = 10;


        let divsWantX = 30;
        let nn_divs_x = this.getDivsNear(divsWantX, this.width);
        let nn_pixels_x = this.width / nn_divs_x;

        let divsWantY = Math.trunc( nn_divs_x * this.height / this.width);  // to get closer to squares rather than rects
        let nn_divs_y = this.getDivsNear(divsWantY, this.height);
        let nn_pixels_y = this.height / nn_divs_y;
        this.nn_grid_size = this.width * this.height / 4;

        this.nn_grid_square_count = nn_divs_x * nn_divs_y;
        let nn_div_size = this.nn_grid_size / this.nn_grid_square_count;

        // nn_divs_x: i32, // nearest neighbors grid divisions
        this.data[9] = nn_divs_x;

    // nn_divs_y: i32, // nearest neighbors grid divisions
        this.data[10] = nn_divs_y;

        // nn_pixels_x : i32,// size of grid rect in pixels
        this.data[11] = nn_pixels_x;

        // nn_pixels_y : i32,   // size of grid rect in pixels
        this.data[12] = nn_pixels_y;

        // nn_div_size : i32,   // how many blob indices can fit into this grid division
        this.data[13] = nn_div_size;

        //lighting_tolerance
        this.data[14] = 0.1;
        
        //padding
        this.data[15] = 0;

        return this.data;
    }

}